import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameMode} from "../../server/DasUBootGameMode";
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {FreeSpinIntro} from "./FreeSpinIntro";
import {LocalPresentation} from "../../runnerpresentations/LocalPresentation";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class FreespinIdlePresentation implements FlowStatePresentation {
    private _presentations:SimplePresentation[];
    private _flowStateController:FlowStateController;

    constructor() {
        this._presentations = [
            new FreeSpinIntro(),
        ]

    }

    start(flowStateController:FlowStateController):void {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?:Function) => flowStateController.setSkipCallback(callback));
    }

    public complete(){
        SlotGame.keypadPlugin.setZeroBetSpinCounter(Math.max(DasUBoot.model.data.freespinsLeft-1,0));
        SlotGame.apiPlugin.betHandler.zeroBet();
        this._flowStateController.finish();

    }
}